import { computeParticipationTotal, computePrestationCommiteeAmount } from '@cpce/shared';
import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { EntityLink } from '@/components/StyledLink';
import type { PrestationParticipationFormatted } from '@/features/beneficiaries/beneficiaries.types';
import { formatDate } from '@/utils/date.utils';
import { formatDecimalAsPrice } from '@/utils/string.utils';

const columnHelper = createColumnHelper<PrestationParticipationFormatted>();

export const activitiesColumns = [
  columnHelper.accessor('prestation.name', {
    header: 'Prestation',
    cell: ({ row, getValue }) => (
      <EntityLink entity="prestation" id={row.original.prestationId}>
        {getValue()}
      </EntityLink>
    ),
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor((row) => row.date, {
    id: 'date',
    header: 'Date',
    cell: (info) => formatDate(info.getValue()),
    meta: { filterType: 'numeric' },
  }),
  columnHelper.accessor('statusFormatted', {
    header: 'Statut',
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor((row) => computeParticipationTotal(row).toNumber(), {
    id: 'price',
    header: 'Prix',
    cell: (info) => formatDecimalAsPrice(computeParticipationTotal(info.row.original)),
    meta: { filterType: 'numeric' },
  }),
  columnHelper.accessor((row) => computePrestationCommiteeAmount(row).toNumber(), {
    id: 'cse',
    header: 'Part CSE',
    cell: (info) => formatDecimalAsPrice(computePrestationCommiteeAmount(info.row.original)),
    meta: { filterType: 'numeric' },
  }),
] as ColumnDef<PrestationParticipationFormatted>[];
